import HttpService from './http.service';

class ProfileService {
  getProfile() {
    return HttpService.get('me')
      .then((res) => res.data);
  }

  updateProfile(profile) {
    return HttpService.patch('me', profile)
      .then((res) => res.data);
  }
}

export default new ProfileService();
